import React, { useEffect, useState } from "react";
import {
  Spinner,
  Button,
  Input,
  Form,
  Label,
} from "reactstrap";
import axiosInstance from '../request';
import { URL } from '../api'; 
import getPrivilegeList from "./PrivilegeList";
import { useLocation } from "react-router-dom";

const DisbursementList = () => {
  const [disbursements, setDisbursements] = useState([]);
  const [loading, setLoading] = useState(false);
  const location = useLocation();

  // Filters
  const [filterType, setFilterType] = useState("customerId");
  const [filterValue, setFilterValue] = useState("");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");

  const companyCode = localStorage.getItem("companyCode");
  const branchCode = localStorage.getItem("branch_code");

  // Status filter
  const [statusList, setStatusList] = useState([]);
  const [selectedStatus, setSelectedStatus] = useState("");

  // Pagination

const [currentPage, setCurrentPage] = useState(1);
const rowsPerPage = 10;
const [hasNextPage, setHasNextPage] = useState(false);

const buildFilters = () => {
  const filters = {};
  if (filterValue.trim()) filters[filterType] = filterValue.trim();
  if (fromDate) filters.fromDate = fromDate;
  if (toDate) filters.toDate = toDate;
  if (selectedStatus) filters.status = selectedStatus;
  return filters;
};



  const privilegeList = getPrivilegeList();

  const formatDateForAPI = (dateString) => {
    if (!dateString) return "";
    return dateString;
  };

  // Fetch disbursements
  const fetchDisbursements = async (page = 1, filters = {}) => {
  setLoading(true);
  try {
    const params = new URLSearchParams();
    

    // filters
    Object.keys(filters).forEach(key => {
      if (filters[key]) params.append(key, filters[key]);
    });
    
    // company / branch filter
if (companyCode) params.append("companyCode", companyCode);
if (companyCode && branchCode) params.append("branchCode", branchCode);
    // pagination params (🔥 IMPORTANT)
    params.append("page", page - 1);   // backend zero based
    params.append("size", rowsPerPage);

    const res = await axiosInstance.get(
      `${URL.DISBURSAL_LIST}?${params.toString()}`
    );

    const data = Array.isArray(res.data) ? res.data : [];

    setDisbursements(data);
    setCurrentPage(page);

    // 🔑 same trick as LoanList
    setHasNextPage(data.length === rowsPerPage);

  } catch (err) {
    console.error(err);
    setDisbursements([]);
    setHasNextPage(false);
  } finally {
    setLoading(false);
  }
};

  // Initial fetch
  useEffect(() => {
    fetchDisbursements();
  }, []);

  // Fetch status list
  useEffect(() => {
  const fetchStatusList = async () => {
    try {
      const response = await axiosInstance.get(URL.DISBURSAL_STATUS);
      setStatusList(response.data);
    } catch (error) {
      console.error("Error fetching status list", error);
      setStatusList([]);
    }
  };

  fetchStatusList();
}, []);


  // Handle search/filter
const handleSearch = (e) => {
  e.preventDefault();
  const filters = {};
  if (filterValue.trim()) filters[filterType] = filterValue.trim();
  if (fromDate) filters.fromDate = fromDate;
  if (toDate) filters.toDate = toDate;
  if (selectedStatus) filters.status = selectedStatus;

  fetchDisbursements(1, filters);
};


  // Fetch with all filters
  const fetchFilteredDisbursements = () => {
    const filters = {};
    if (filterValue.trim()) filters[filterType] = filterValue.trim();
    if (fromDate) filters.fromDate = formatDateForAPI(fromDate);
    if (toDate) filters.toDate = formatDateForAPI(toDate);
    if (selectedStatus) filters.status = selectedStatus; // send status param

    fetchDisbursements(1, filters);

  };

  // Auto filter on status change
  useEffect(() => {
    fetchFilteredDisbursements();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedStatus]);

  const currentLabel = {
    customerId: "Customer ID",
    loanId: "Loan ID",
  }[filterType];



  return (
    <div className="container" style={{ fontSize: "14px" }}>
      <h3 className="mb-4">Disbursement List</h3>

      {/* Filter Form */}
      <Form onSubmit={handleSearch} className="mb-3">
        <div className="row g-3">
          <div className="col-md-2">
            <Label className="form-label fw-bold">Filter Type</Label>
            <Input
              type="select"
              value={filterType}
              onChange={(e) => setFilterType(e.target.value)}
              bsSize="sm"
            >
              <option value="customerId">Customer ID</option>
              <option value="loanId">Loan ID</option>
            </Input>
          </div>

          <div className="col-md-2">
            <Label className="form-label fw-bold">{currentLabel}</Label>
            <Input
              type="text"
              value={filterValue}
              onChange={(e) => setFilterValue(e.target.value)}
              placeholder={`Enter ${currentLabel}`}
              bsSize="sm"
            />
          </div>

          <div className="col-md-2">
            <Label className="form-label fw-bold">From Date</Label>
            <Input
              type="date"
              value={fromDate}
              onChange={(e) => setFromDate(e.target.value)}
              bsSize="sm"
            />
          </div>

          <div className="col-md-2">
            <Label className="form-label fw-bold">To Date</Label>
            <Input
              type="date"
              value={toDate}
              onChange={(e) => setToDate(e.target.value)}
              bsSize="sm"
            />
          </div>

          <div className="col-md-2">
            <Label className="form-label fw-bold">Status</Label>
            <Input
              type="select"
              value={selectedStatus}
              onChange={(e) => setSelectedStatus(e.target.value)}
              bsSize="sm"
            >
              <option value="">All</option>
              {statusList.map((status, index) => (
                <option key={index} value={status}>
                  {status}
                </option>
              ))}
            </Input>
          </div>

          <div className="col-md-2 d-flex align-items-end">
            <Button color="primary" type="submit" size="sm">
              Search
            </Button>
          </div>
        </div>
      </Form>

      {/* Loading */}
      {loading ? (
        <div className="d-flex align-items-center mt-3" style={{ gap: 8 }}>
          <Spinner size="sm" /> <span>Loading disbursement list...</span>
        </div>
      ) : (
      <div className="table-responsive" style={{ overflowX: 'auto', whiteSpace: 'nowrap' }}>
        <table className="table tablestyle table-sm table-bordered table-hover align-middle">
            <thead className="table-dark">
              <tr>
                <th>S.No.</th>
                <th>Loan ID</th>
                <th>Customer ID</th>
                <th>Approved Amount</th>
                <th>Disbursal Amount</th>
                <th>Status</th>
                <th>Fintech Name</th>
                <th>Create Date</th>
                <th>Update Date</th>
                {privilegeList.disbursementDetailsView && <th>Action</th>}
              </tr>
            </thead>

            <tbody>
              {disbursements.length > 0 ? (
  disbursements.map((item, index) => (
                  <tr key={index}>
                    <td>{(currentPage - 1) * rowsPerPage + index + 1}</td>
                    <td>{item.loan_id}</td>
                    <td>{item.customer_id}</td>
                    <td>₹{item.approved_amt?.toLocaleString() || "0"}</td>
                    <td>₹{item.disbursal_amt?.toLocaleString() || "0"}</td>
                    <td>
                      <span
                        className={`badge rounded-pill ${
                          item.disbursal_status === "Approved"
                            ? "bg-success"
                            : item.disbursal_status === "Pending"
                            ? "bg-warning text-dark"
                            : "bg-secondary"
                        }`}
                      >
                        {item.disbursal_status}
                      </span>
                      
                    </td>
                    <td>{item.fintech_name}</td>
                    <td>{item.create_date ? new Date(item.create_date).toLocaleDateString() : "-"}</td>
                    <td>{item.update_date ? new Date(item.update_date).toLocaleDateString() : "-"}</td>
                    {privilegeList.disbursementDetailsView && (
                      <td>
                        <button
                          className="btn btn-sm btn-primary me-2"
                          onClick={() =>
                            (window.location.href = `#/DisbursementView?loanId=${item.loan_id}&customerId=${item.customer_id}`)
                          }
                        >
                          View
                        </button>
                      </td>
                    )}
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="9" className="text-center text-muted">
                    No disbursement records found.
                  </td>
                </tr>
              )}
            </tbody>
          </table>

        <div className="d-flex justify-content-center mt-3">
  <div className="d-flex align-items-center" style={{ gap: "8px" }}>

    {/* Prev */}
    <button
      className="btn btn-sm btn-outline-primary"
      onClick={() => fetchDisbursements(currentPage - 1, buildFilters())}
      disabled={currentPage === 1}
    >
      Prev
    </button>

    <span className="px-2">Page {currentPage}</span>

    {hasNextPage && <span className="text-muted">.....</span>}

    {/* Next */}
    <button
      className="btn btn-sm btn-outline-primary"
      onClick={() => fetchDisbursements(currentPage + 1, buildFilters())}
      disabled={!hasNextPage}
    >
      Next
    </button>

  </div>
</div>

        </div>
      )}
    </div>
  );
};

export default DisbursementList;
